import { func, shape, number, array, bool } from 'prop-types';
import { Fragment } from 'react';
import AddItemBox from '../../shared/AddItemBox';
import GeneralSection from './GeneralSection';
import LoanpartSection from './LoanpartSection';
import {useTranslation} from "react-i18next";
import AddressSection from "./AddressSection";
import AdvisorDetails from '../../shared/AdvisorDetails';
import Card from '../../shared/Card';

const MortgageBlock = ({
  mortgage,
  providers,
  errors,
  canEditMortgage,
  setMortgage,
  mortgageIndex,
  addLoanpart,
  setLoanpart,
  removeLoanpart,
  repaymentTypeOptions,
}) => {
  const { t } = useTranslation();
  const mortgageAmount = mortgage?.originalAmount || 0;
  const advisor = mortgage?.advisor || {};
  const loanpartsSum = (mortgage?.loanparts || []).reduce(
    (total, loanpart) => total + loanpart.originalAmount || 0,
    0
  );

  return (
    <Fragment>
      <GeneralSection
        {...{
          ...mortgage,
          providers,
          errors,
          canEditMortgage,
          mortgageIndex,
        }}
        setMortgage={(e) => setMortgage(e, mortgageIndex)}
      />
      {mortgage?.loanparts?.map((loanpart, loanpartIndex) => (
        <LoanpartSection
          {...loanpart}
          key={loanpart.uuid || loanpartIndex}
          mortgageIndex={mortgageIndex}
          index={loanpartIndex}
          removable={mortgage?.loanparts.length > 1}
          setLoanpart={(e) => setLoanpart(e, mortgageIndex, loanpartIndex)}
          removeLoanpart={() => removeLoanpart(mortgageIndex, loanpartIndex)}
          errors={errors}
          repaymentTypeOptions={repaymentTypeOptions}
          canEditMortgage={canEditMortgage}
        />
      ))}
      {mortgageAmount > 0 &&
        mortgageAmount > loanpartsSum &&
        canEditMortgage && (
          <AddItemBox
            title={t("Leningdeel toevoegen")}
            onClick={() =>
              addLoanpart(mortgageIndex, mortgageAmount - loanpartsSum)
            }
          />
        )}
      {mortgage?.houseAddresses?.map((address, addressIndex) => (
        <AddressSection
          key={`address-${addressIndex}`}
          {...address}
          addressIndex={addressIndex}
        />
      ))}
      {Object.keys(advisor).length > 0 && (
        <Card>
          <AdvisorDetails {...advisor} />
        </Card>
      )}
    </Fragment>
  );
};

MortgageBlock.propTypes = {
  mortgage: shape({}),
  providers: array,
  errors: shape({}),
  canEditMortgage: bool,
  setMortgage: func.isRequired,
  mortgageIndex: number.isRequired,
  addLoanpart: func.isRequired,
  setLoanpart: func.isRequired,
  removeLoanpart: func.isRequired,
  repaymentTypeOptions: array,
};

MortgageBlock.defaultProps = {
  mortgage: {},
  providers: [],
  errors: {},
  canEditMortgage: false,
  repaymentTypeOptions: [],
};

export default MortgageBlock;
